import React from "react";
import { useParams } from "react-router-dom";
import { CompanyList } from "./index";
import CompanyDetails from "./details";
import Catalog from "../catalog/page";

export default function CompanyListPage() {
  return (
    <div className="container mt-3">
      <div className="card shadow p-3 mb-5 bg-white rounded border-0">
        <CompanyList />
      </div>
    </div>
  );
}

export function CompanyDetailsPage() {
  const { companyId } = useParams();
  return (
    <div className="container mt-3">
      <CompanyDetails companyId={companyId} />
    </div>
  );
}
